<template>
    <div class="text-right flex-inline">
        <button v-if="cancelButton" :disabled="disabled" type="button" :class="cancelClass" @click="$emit('cancel')" v-html="cancelLabel" />
        <button
            v-if="submitButton"
            v-focus="focus"
            :disabled="disabled"
            type="submit"
            :class="submitClass"
            @click="$emit('submit')"
            v-html="submitLabel"
        />
    </div>
</template>

<script type="text/babel">
import Focus from '@makeabledk/vue-ui/directives/focus'

export let config = {
    cancelButton: true,
    cancelClass: 'Button --lg --no-spin',
    cancelLabel: 'Cancel',
    submitButton: true,
    submitClass: 'Button --lg --blue',
    submitLabel: 'Submit',
}

export default {
    directives: { Focus },

    props: {
        cancelButton: {
            default() {
                return config.cancelButton
            },
        },
        cancelClass: {
            default() {
                return config.cancelClass
            },
        },
        cancelLabel: {
            default() {
                return config.cancelLabel
            },
        },
        submitButton: {
            default() {
                return config.submitButton
            },
        },
        submitClass: {
            default() {
                return config.submitClass
            },
        },
        submitLabel: {
            default() {
                return config.submitLabel
            },
        },
        focus: {
            default: false,
        },
        disabled: {
            default: false,
        },
    },

    emits: ['cancel', 'submit'],
}
</script>
